var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6094 10L12.6094 13H9.60938V17H12.6094L15.6094 20V10ZM17.2175 10.8646L17.0719 11.408C18.699 11.8439 19.8282 13.3155 19.8282 15C19.8282 16.6845 18.699 18.1561 17.0719 18.592L17.2175 19.1354C19.0879 18.6342 20.3907 16.9363 20.3907 15C20.3907 13.0637 19.0879 11.3658 17.2175 10.8646ZM16.8292 12.3135L16.6837 12.8569C17.655 13.1171 18.3282 13.9944 18.3282 15C18.3282 16.0056 17.655 16.8829 16.6837 17.1431L16.8292 17.6865C18.0439 17.361 18.8907 16.2574 18.8907 15C18.8907 13.7426 18.0439 12.639 16.8292 12.3135ZM16.441 13.7624L16.2954 14.3057C16.6109 14.3903 16.8281 14.6733 16.8281 15C16.8281 15.3267 16.6109 15.6097 16.2954 15.6943L16.441 16.2376C16.9999 16.0879 17.3907 15.5786 17.3907 15C17.3907 14.4214 16.9999 13.9121 16.441 13.7624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.26d51f3b1405dbdbbc473a5f35b5de8f.svg";
export { ForwardRef as ReactComponent };